import React, { PureComponent } from 'react';

import { Button } from 'components/button';
import { SelectLanguages } from 'components/input/select';
import { I18n } from 'components/translate';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import PlayerService from '../PlayerService';

import './PlayerLanguageSelector.scss';

@inject((stores) => ({ languages: stores.PlayerStore.supportedLangs }))
@observer
export default class PlayerLanguageSelector extends PureComponent {
  state = {
    selectedLang: ''
  };

  static propTypes = {
    mediaId: PropTypes.string,
    languages: PropTypes.array,
    onLanguageConfirmed: PropTypes.func,
    error: PropTypes.bool
  };

  constructor(props) {
    super(props);

    PlayerService.setSupportedLangs();
  }

  render() {
    const { error, languages } = this.props;

    return (
      <div className="player__language-selector">
        <label>
          <I18n label="player_section.select_language" />
        </label>

        <SelectLanguages
          error={error}
          placeholder="player_subtitles.placeholder_gateway_language"
          className="player__language-selector__input"
          languages={languages}
          onSelectLang={this.onSelectLang}
        />

        <Button
          outline
          size="large"
          disabled={!this.state.selectedLang}
          className="player__language-selector__button"
          onClick={this.onClickContinue}
        >
          <I18n label="general.continue" />
        </Button>
      </div>
    );
  }

  onSelectLang = (selectedLang) => {
    this.setState({ selectedLang });
  };

  onClickContinue = () => {
    const { onLanguageConfirmed } = this.props;
    const { selectedLang } = this.state;

    onLanguageConfirmed && onLanguageConfirmed(selectedLang);
  };
}
